<template>
  <section class="copper">
    <p>
      Медь обладает коррозионной устойчивостью, высокой прочностью, хорошей пластичностью, стойкостью к низким температурам и бактериостатичностью по отношению к микроорганизмам. При отрицательных температурах пластичность и прочность меди не уменьшаются,
      как у многих других материалов, а возрастают. Возможен монтаж медных трубопроводов и их эксплуатация (незамерзающие жидкости и газы) в зимних условиях.
    </p>
    <p>
      При расширении замерзшей воды в трубопроводе, благодаря пластичности, медные трубы могут деформироваться без разрыва от 1 до 3 раз. Поэтому их рекомендуется использовать на объектах с риском аварийного замораживания в зимний период. Медные трубы
      не стареют и не портятся; при грамотной эксплуатации, медный трубопровод питьевого водоснабжения (по опыту Европы) массово "доживает" до 80 лет и более.
    </p>
    <p>
      В медных трубопроводах, соединения - самые надёжные части системы. Пайка и прессование технологически обеспечивают высокую надёжность соединения, практически независимо от тщательности монтажника, в отличие от сварки и иных способов.
    </p>
  </section>
</template>

<script>
  export default {

  }
</script>

<style scoped>

p {
  text-align: justify;
  text-indent: 50px;
  padding: 10px;
  font-size: 2em;
  max-width: 1600px;
}

@media (max-width: 1400px) {
  p {
    margin-right: 5%;
    margin-left: 5%;
  }
}

@media (max-width: 800px) {
  p {
    font-size: 1.2em;
  }
}

@media (max-width: 400px) {
  p {
    font-size: 1em;
  }
}

</style>